export const IS_PRODUCTION = process.env.NODE_ENV === 'production'

export const HTTP_HEADER_SKIP_ERROR = 'Winner-Skip-Error'
export const HTTP_STATUS = {
  badRequest: 400,
  unauthrized: 401,
  unprocessableEntity: 422
}

export const STORAGE_ITEM = {
  authToken: 'portfolio_partner_demo_auth'
}

export const AUTH_COOKIE = {
  name: 'portfolio_partner_demo_auth',
  expires: (1 / 1440 * process.env.VUE_APP_LOGIN_TIME) || (1 / 12),
  path: '/'
}

export const LANG_COOKIE = {
  name: 'winner_lang',
  path: '/'
}

export const BOARD_COOKIE = {
  name: 'winner_boardList',
  path: '/'
}

// if (IS_PRODUCTION) {
// AUTH_COOKIE.domain = '.naver.com'
// }

export const GAME_CATEGORY = [
  // { name: '전체', icon: require('@/assets/img/all.png'), value: 'all', use: true },
  { name: 'front.gnb.livecasino', icon: require('@/assets/img/live_casino.png'), value: 'casino', use: true },
  { name: 'front.gnb.slot', icon: require('@/assets/img/slot.png'), value: 'slot', use: true },
  { name: 'front.gnb.sport', icon: require('@/assets/img/sports.png'), value: 'sport', use: true },
  { name: 'front.gnb.minigame', icon: require('@/assets/img/minigame.png'), value: 'minigame', use: true }
  //  { name: 'e-스포츠', icon: require('@/assets/img/e_sports.png'), value: 'esport', use: true },

//  { name: '가상게임', icon: require('@/assets/img/virtualgame.png'), value: 'kiron', use: true }
  // { name: '피싱게임', icon: require('@/assets/img/fishinggame.png'), value: 'fishing', use: true }
  // ,{ name: '로터리게임', icon: require('@/assets/img/rotary.png'), value: 'rotary', use: true }
]

export const GAME_DETAIL_INFO = {
  evolution: 1,
  biggaming: 2,
  asiagaming: 5,
  dreamgaming: 6,
  sexygaming: 9,
  pragmaticplay: 10,
  playtech: 12,
  hotelcasino: 14,
  slot: 0,
  pragmaticslot: 200,
  hananero: 201,
  elysium: 202,
  fishing: 1000
}

export const SPORT_GAME_CATEGORY = [
  { value: 'all', name: '전체', use: true, default: true, img: require('@/assets/img/all.png') },
  { value: 'soccer', name: '축구', use: true, img: require('@/assets/img/sports.png') },
  { value: 'basketball', name: '농구', use: true, img: require('@/assets/img/basket.png') },
  { value: 'baseball', name: '야구', use: true, img: require('@/assets/img/base.png') },
  { value: 'volleyball', name: '배구', use: true, img: require('@/assets/img/volley.png') },
  { value: 'badminton', name: '배드민턴', use: true, img: require('@/assets/img/tennis.png') },
  { value: 'hockey', name: '하키', use: true, img: require('@/assets/img/hockey2.png') },
  { value: 'combat', name: '격투기', use: true, img: require('@/assets/img/betting.png') }
]

export const SPORT_GAME_CATEGORY2 = [
  { value: 'soccer', name: '축구', use: true, img: require('@/assets/img/sports.png'), imgs: true },
  { value: 'basketball', name: '농구', use: true, img: require('@/assets/img/basket.png'), imgs: true },
  { value: 'baseball', name: '야구', use: true, img: require('@/assets/img/base.png'), imgs: true },
  { value: 'volleyball', name: '배구', use: true, img: require('@/assets/img/volley.png'), imgs: true },
  { value: 'tennis', name: '테니스', use: true, img: require('@/assets/img/tennis.png'), imgs: true },
  { value: 'hockey', name: '하키', use: true, img: require('@/assets/img/hockey2.png'), imgs: true },
  { value: 'handball', name: '핸드볼', use: true, img: require('@/assets/img/handball.png'), imgs: true },
  { value: 'football', name: '미식축구', use: true, img: require('@/assets/img/rugby.png'), imgs: true },
  { value: 'esport', name: 'e-스포츠', use: true, img: require('@/assets/img/e_sports.png'), imgs: true }
]

export const DOCUMENT_TITLE_PREFIX = process.env.VUE_APP_TITLE || ''

export const CASH_STATUS = {
  0: {
    class: 'poss',
    text: '신청'
  },
  1: {
    class: 'blc',
    text: '완료'
  },
  2: {
    class: '',
    text: '대기'
  },
  '-1': {
    class: '',
    text: '취소'
  }
}

export const CASH_STATUS_MOBILE = {
  0: {
    class: 'poss',
    text: '신청'
  },
  1: {
    class: 'done',
    text: '완료'
  },
  2: {
    class: '',
    text: '대기'
  },
  '-1': {
    class: 'cancel',
    text: '취소'
  }
}

export const PARTNER_LEVEL_NAME = {
  PTN_1: '대본',
  PTN_2: '본사',
  PTN_3: '부본',
  PTN_4: '총판',
  PTN_5: '매장',
  PTN_6: '지점',
  PTN_7: '팀',
  NORMAL: '회원'
}

export const PARTNER_LEVEL_LIST = [
  'PTN_1', 'PTN_2', 'PTN_3', 'PTN_4', 'PTN_5', 'PTN_6', 'PTN_7'
]

export const PARTNER_LEVEL_ORDER = {
  PTN_1: 1,
  PTN_2: 2,
  PTN_3: 3,
  PTN_4: 4,
  PTN_5: 5,
  PTN_6: 6,
  PTN_7: 7,
  NORMAL: 8
}

export const SOCKET_SERVER_URL = process.env.VUE_APP_WEB_SOCKET_URL || 'http://54.168.76.109/websocket'
export const SOCKET_SUBSCRIBE_DESTINATION = '/topic/'
export const SOCKET_POWERBALL_SUBSCRIBE_DESTINATION = '/topic/powerball/'

export const TRIPLE_GAME_LIST = {
}

export const NonIframeGameCode = [
  '1',
  '13'
]

export const PARTNER_MOBILE_TABLE_SITE = [
  'brown789'
]

export const SPORT_BRANCH_LIST = {
  1: '축구',
  2: '농구',
  3: '미식축구',
  6: '테니스',
  7: '야구',
  8: '아이스하키',
  9: '스페셜',
  10: '핸드볼',
  14: 'Motor Racing',
  17: 'Poker',
  23: 'Hockey',
  19: '배구',
  34: '배드민턴',
  43: 'MMA',
  45: '수영',
  64: 'E-스포츠',
  218: '가상축구',
  219: '가상농구',
  220: '롤',
  221: 'DOTA2',
  222: 'CSGO',
  0: '기타'
}

export const STATUS_LIST = {
  Opened: '경기시작 전',
  Draw: '무승부',
  Won: '승리',
  Lost: '패배'
}

export const CASH_TYPE_LIST = {
  1: '입금',
  '-1': '출금',
  2: '관리자 지급',
  '-2': '관리자 회수',
  '-3': '보유금 지급',
  3: '보유금 회수',
  33: '상부 지급',
  '-33': '상부 회수',
  4: '포인트 전환'
}
